<div class="footer">
  <span class="side side--left col-sm-12">
    <div>
      <div><img class="side__AC-logo" src="public/images/Essity-white.png" alt="Essity" /></div>
      <div>
        <p class="side__copy-right">© 2022 Essity Australasia</p>
      </div>
    </div>
  </span>
  <cx-navigation-ui
    class="links col-sm-12"
    [node]="node$ | async"
    [flyout]="false"
    [ngClass]="styleClass$ | async"
  ></cx-navigation-ui>

  <span class="side side--right col-sm-12">
    <div class="side__contact">
      <p class="side__contact__content">General Customer Enquiries:</p>
      <p class="side__contact__content">Telephone: 1800 643 634 (within Australia)</p>
      <p class="side__contact__content">Telephone: 0800 523 565 (within New Zealand)</p>
      <p class="side__contact__content">
        Email address:
        <a href="mailto:customerservice.anz@essity.com">customerservice.anz&#64;essity.com</a>
      </p>
      <div class="side__contact__socials">
        <a href="https://www.linkedin.com/company/essity/" target="_blank"><i class="fab fa-linkedin"></i></a>
        <a href="https://www.facebook.com/essity" target="_blank"><i class="fab fa-facebook-square"></i></a>
        <a href="https://www.youtube.com/channel/UCv5LMehTcMvdcUUpEVNTVGA" target="_blank"
          ><i class="fab fa-youtube-square"></i
        ></a>
      </div>
    </div>
  </span>
</div>
